import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-grafico-nivel',
  templateUrl: './grafico-nivel.component.html',
  styleUrls: ['./grafico-nivel.component.css']
})
export class GraficoNivelComponent implements OnInit {

  @Input() public cuartoBasico: any;

  constructor() { }

  ngOnInit() {
  }

}
